export function getRecommendationMicroservice() {
  const recommendationMicroservice = process.env.OCELOT_RECOMMENDATION_MICROSERVICE;
  if (!recommendationMicroservice) throw new Error('Missing env: OCELOT_RECOMMENDATION_MICROSERVICE');
  return recommendationMicroservice;
}
